import {ApplicationConfig, importProvidersFrom, isDevMode} from '@angular/core';
import {provideRouter} from '@angular/router';

import {routes} from './app.routes';
import {provideAnimations} from '@angular/platform-browser/animations';
import {provideHttpClient} from "@angular/common/http";
import {getApp, initializeApp, provideFirebaseApp} from '@angular/fire/app';
import {getAnalytics, provideAnalytics, ScreenTrackingService} from '@angular/fire/analytics';
import {initializeAppCheck, ReCaptchaEnterpriseProvider, provideAppCheck} from '@angular/fire/app-check';
import {
  enableIndexedDbPersistence,
  getFirestore,
  initializeFirestore,
  persistentLocalCache, persistentMultipleTabManager,
  provideFirestore
} from '@angular/fire/firestore';
import {getFunctions, provideFunctions} from '@angular/fire/functions';
import {getPerformance, providePerformance} from '@angular/fire/performance';
import {provideServiceWorker} from '@angular/service-worker';
import {getStorage, provideStorage} from "@angular/fire/storage";
import {getAuth, provideAuth} from "@angular/fire/auth";

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(),
    importProvidersFrom(provideFirebaseApp(() => initializeApp({
      "projectId": "audiotour-2e51a",
      "appId": "1:402164708991:web:56119c9566dc96c6f6b14a",
      "storageBucket": "audiotour-2e51a.appspot.com",
      "apiKey": "AIzaSyB5p1xat27pVKraQQfA5JxsdJzB6ZPKZVQ",
      "authDomain": "audiotour-2e51a.firebaseapp.com",
      "messagingSenderId": "402164708991",
      "measurementId": "G-LR849CMRYQ"
    }))),
    importProvidersFrom(provideAnalytics(() => getAnalytics())),
    ScreenTrackingService,
    // importProvidersFrom(provideAppCheck(() => {
    //   // TODO get a reCAPTCHA Enterprise here https://console.cloud.google.com/security/recaptcha?project=_
    //   const provider = new ReCaptchaEnterpriseProvider("6LeqzUspAAAAAKfCNuvFzHAxDBuSnAAxIemO_LDn");
    //   return initializeAppCheck(undefined, {provider, isTokenAutoRefreshEnabled: true});
    // })),
    importProvidersFrom(
      provideFirestore(() =>
        initializeFirestore(getApp(), {
          localCache: persistentLocalCache({
            tabManager: persistentMultipleTabManager(),
          }),
        })
      ),
    ),
    importProvidersFrom(provideFunctions(() => {
      const functions = getFunctions();
      functions.region = 'europe-west3';
      return functions;
    })),
    importProvidersFrom(providePerformance(() => getPerformance())),
    importProvidersFrom(provideStorage(() => getStorage())),
    importProvidersFrom(provideAuth(() => {
      const auth = getAuth();
      auth.useDeviceLanguage();
      return auth;
    })),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    })
  ]
};
